module.exports = __webpack_public_path__ + "static/orthodontics05-64b6cd38b5147bdac2351fe5b740ad22.jpg";